import { MapContainer as Map, TileLayer, ZoomControl } from 'react-leaflet'
import { MapLayersEnum } from '../../../../constants/enums'
import { SearchField } from '../../../../components/SearchField/SearchField'
import { MAP_URL } from '../../../../constants/urls'
import { useActions } from '../../../../hooks/redux/actions'
import { useAppSelector } from '../../../../hooks/redux/redux'
import { useInitialPosition } from '../../../../hooks/useInitialPosition'
import { useGetPointsMutation, useGetEventsMutation } from '../../../../store'
import { Locations } from '../Locations/Locations'
import { MapEventHandlers } from '../MapEventHandlers/MapEventHandlers'
import { Markers } from '../Markers/Markers'
import { NewPointMarker } from '../NewPointMarker/NewPointMarker'
import { NewEventMarker } from '../NewEventMarker/NewEventMarker'
import css from './MapContainer.module.scss'

export const MapContainer = () => {
  const {
    isNewPointFormOpened,
    isNewPointOpened,
    isNewEventFormOpened,
    mapLayer,
  } = useAppSelector((state) => state.app)
  const { centerLat, centerLng, zoom, bounds } = useInitialPosition()
  const [fetchPoints] = useGetPointsMutation()
  const [fetchEvents] = useGetEventsMutation()
  const { setCurrentPoints, setCurrentEvents } = useActions()

  if (!centerLat || !centerLng) return null

  return (
    <Map
      key={`${centerLat}-${centerLng}`}
      center={[centerLat, centerLng]}
      zoom={zoom}
      minZoom={3}
      scrollWheelZoom={true}
      zoomControl={false}
      keyboard={true}
      keyboardPanDelta={80}
      className={css.mapContainer}
      maxBoundsViscosity={1.0}
      maxBounds={[
        [-90, -180],
        [90, 180],
      ]}
      whenReady={() => {
        fetchPoints(bounds)
          .unwrap()
          .then((value) => {
            if (value?.length > 0) {
              setCurrentPoints(value)
            }
          })
        fetchEvents(bounds)
          .unwrap()
          .then((value) => {
            setCurrentEvents(value)
          })
      }}
    >
      <MapEventHandlers />
      {mapLayer === MapLayersEnum.googleMaps && (
        <TileLayer
          className={css.tileLayer}
          attribution={mapLayer}
          url={MAP_URL[mapLayer].url}
          noWrap={true}
        />
      )}
      {mapLayer === MapLayersEnum.googleMapsSatellite && (
        <TileLayer
          className={css.tileLayer}
          attribution={mapLayer}
          url={MAP_URL[mapLayer].url}
          subdomains={MAP_URL[mapLayer].subdomains}
        />
      )}
      <Locations />
      <Markers />
      {(isNewPointFormOpened || isNewPointOpened) && <NewPointMarker />}
      {isNewEventFormOpened && <NewEventMarker />}
      <ZoomControl position="bottomright" />
      <SearchField />
    </Map>
  )
}
